import React from "react"
import CTAButton from "src/components/common/CTAButton"
import { StyledSplitSection } from "src/components/common/StyledSplitSection"
import styled from "styled-components"

const PutYourShowSection = () => {
  return (
    <StyledPutYourShowSection>
      <div className="image-side">
        <div className="image-container">
          <div className="image">
            <img
              src="https://assets-imgx.fubo.tv/marketing/lp/images/fsn/contact/on-our-channel-2025.jpg?ch=width&auto=format,compress"
              alt=""
            />
          </div>
        </div>
      </div>
      <div className="content-side">
        <div className="content">
          <h2>
            Put Your Show <br />
            on Our Channel
          </h2>
          <p>
            Fubo Sports Network viewers are hungry for sports content like
            yours. Contact us about adding your show.
          </p>
          <CTAButton link="mailto:ibonebrake@fubo.tv">
            Contact Issy Bonebrake
          </CTAButton>
        </div>
      </div>
    </StyledPutYourShowSection>
  )
}

export default PutYourShowSection

const StyledPutYourShowSection = styled(StyledSplitSection)`
  background: #0d0f21;
  @media (max-width: 767px) {
    flex-direction: column-reverse;
    .image-side {
      align-self: flex-start;
    }
  }
  .image-side {
    .image-container {
      border-left: none;
      border-radius: 0 300px 300px 0;
      padding: 10px 10px 10px 0;
      .image {
        border-radius: 0 300px 300px 0;
      }
    }
  }
`
